<script setup>
import AppSnackbar from '@/components/global/AppSnackbar.vue'
import ConfirmDialog from '@/components/global/modalComponent.vue'
import { useAppTheme } from '@/composables/global/useAppTheme'
import { provide, ref } from 'vue'
import { useTheme } from 'vuetify'

const { loadTheme } = useAppTheme()
const confirmDialog = ref(null)
const snackbarRef = ref(null)
const vuetifyTheme = useTheme()

loadTheme()

// Restaurar dark/light mode por usuario al recargar la página
const savedUser = JSON.parse(localStorage.getItem('user') || '{}')
if (savedUser?.id) {
  const savedMode = localStorage.getItem(`theme-mode-${savedUser.id}`)
  if (savedMode && ['light', 'dark'].includes(savedMode))
    vuetifyTheme.global.name.value = savedMode
}

// ✅ Snackbar global
provide('snackbar', {
  open: (message, type = 'success') => {
    snackbarRef.value?.open(message, type)
  },
})

// ✅ Confirm dialog global
provide('confirm', options => {
  return confirmDialog.value.open(options)
})

const cached = localStorage.getItem('appTheme')
if (cached) {
  const { applyTheme } = useAppTheme()

  applyTheme(JSON.parse(cached))
}
</script>

<template>
  <VApp>
    <RouterView />

    <!-- Global components -->
    <ConfirmDialog ref="confirmDialog" />
    <AppSnackbar ref="snackbarRef" />
  </VApp>
</template>
